import React, { useEffect, useRef, useState } from "react"
import { Box, Button, Checkbox, Flex, FormControl, FormLabel, Heading, Input, Menu, MenuButton, MenuItem, MenuList, Select, Spinner, Tooltip, Wrap, WrapItem } from "@chakra-ui/react"
import { Layout } from "../../GlobalComponent/Layout/Layout"
import { addAgent, addSlotToRoster, fetchRoster, updateData } from "./Action/action"
import { ChevronDownIcon, InfoIcon } from "@chakra-ui/icons"
import PriorityDragDrop from "./data"
import { toast } from "react-toastify"
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getAllagent } from "../../Http/Index"



export const CallRoster = () => {
    const [data, setData] = useState<any>([])
    const [selectedSlots, setSelectedSlots] = useState<any>([])
    const didMountRef = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [agentData,setAgentData] = useState<any>([]);
    const [uniqueAgentMapping,setUiqueAgentMapping]=useState<any>({});
    const [agentToEdit,setAgentToEdit]=useState<any>({})
    const [newSlotData, setNewSlotData] = useState<any>({
        day: "", slotName: "", slotStartTime: "", slotEndTime: "",
    });
    const [formData, setFormData] = useState<any>({
        _id: "",
        Day: "",
        Slot: "",
        name: "",
        agentId: "",
        number: "",
        priority: "",
        languages: [],
    });
    const languageOptions: any[] = ["English", "Hindi", "Malyalam", "Marathi", "Tamil", "Kannada", "Telugu"];
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];




    useEffect(() => {

        fetchData()
        fetchAllAgents()
    }, [])


    async function fetchData() {
        let data = await fetchRoster()
        let mappedAgent=data?.data.reduce((acc: any, curr: any) => {
            curr.slots.forEach((slot: any) => {
                slot.agents.forEach((agent: any) => {
                    if (!acc[agent.agentName]) {
                        acc[agent.agentName] = { [agent.agentName]: agent.preferredLanguage || [] ,"agentId":agent.agentId};
                    }
                });
            });
            return acc;
        }, {});
        setUiqueAgentMapping(mappedAgent)
        setData(data?.data)

    }

    async function fetchAllAgents(){
        let data=await getAllagent()
        setAgentData(data?.data?.data||[])
        return data?.data

    }

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = event.target;

        setFormData((prev: any) => ({

            ...prev,
            [name]: value,
        }));
        if (name === "Slot") {
            const currentSlot = selectedSlots.find((slot: any) => slot.slotId === value);
            const prioritySlots = getNextPriority(currentSlot?.agents || []);
            setFormData((prev: any) => ({
                ...prev,
                priority: prioritySlots
            }));

        }
        if(name==="name"){
            let selectedAgent = agentData.find((agent: any) => agent.agentName === value);
       
            if (selectedAgent) {
                
               
                setFormData((prev: any) => ({
                    ...prev,
                    agentId: selectedAgent.agentId,
                    number: selectedAgent.agentPhoneNumber,
                    languages: uniqueAgentMapping?.[selectedAgent?.agentName]?.[selectedAgent?.agentName] || [],
                }));
            }

        }


    };


    const getNextPriority = (agents: any[] = []) => {
        if (!Array.isArray(agents) || agents.length === 0) return 1;
        const priorities = agents.map(agent => agent.priority ?? 1);
        const max = Math.max(...priorities, 1);
        return max + 1;
    };

    const handleAddAgent = async () => {
       
        let checkAllFiedl = validateFormData()
        if (!checkAllFiedl.isValid) {
            toast.warning(`Please fill in a valid value for: ${checkAllFiedl.missingField}`);
            return
        }
         setIsLoading(true)
        const agentPayload = {
            agentId: formData.agentId,
            agentName: formData.name,
            agentPhoneNumber: formData.number,
            preferredLanguage: formData.languages,
            priority: formData.priority,
            status: "Ready"
        };


        let response = await addAgent(formData._id, formData.Slot, agentPayload)
        if (response?.StatusCode === 200) {
            toast.success("Successfully added the agent to roster");
            await fetchData()
            setFormData({
                _id: "",
                Day: "",
                Slot: "",
                name: "",
                agentId: "",
                number: "",
                priority: "",
                languages: [],

            })
        } else {
            toast.error(response?.response?.data?.message || "Something went wrong");
        }
        setIsLoading(false)

    }


    const validateFormData = () => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobileRegex = /^[6-9]\d{9}$/;

        if (!formData.Day) return { isValid: false, missingField: "Day" };
        if (!formData.Slot) return { isValid: false, missingField: "Slot" };
        if (!formData.name) return { isValid: false, missingField: "name" };
        if (!formData.agentId) return { isValid: false, missingField: "id" };

        // Email format check (assuming formData.id is used for email)
        if (!emailRegex.test(formData.agentId)) {
            return { isValid: false, missingField: "id (invalid email format)" };
        }

        if (!formData.number) return { isValid: false, missingField: "number" };

        // Mobile number format check
        if (!mobileRegex.test(formData.number)) {
            return { isValid: false, missingField: "number (invalid mobile format)" };
        }

        if (formData.priority === null || formData.priority === "") {
            return { isValid: false, missingField: "priority" };
        }

        if (!Array.isArray(formData.languages) || formData.languages.length === 0) {
            return { isValid: false, missingField: "languages" };
        }

        return { isValid: true };
    };


    useEffect(() => {
        if (!didMountRef.current) {
            // Skip the initial render
            didMountRef.current = true;
            return;
        }

        const filterSlots = data.filter((elem: any) => elem?.day === formData?.Day);
        setSelectedSlots(filterSlots[0]?.slots);


        setFormData((prev: any) => ({
            ...prev,
            _id: filterSlots[0]?._id
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.Day]);


    const handleSlotChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setNewSlotData((prev: any) => ({ ...prev, [name]: value }));
    };

    const timeStrToMinutes = (timeStr: string): number => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
    };

    const handleAddSlot = async () => {
        if (!newSlotData.day) {
            toast.warning("Please select a Day before adding a slot.");
            return;
        }

        if (!newSlotData.slotName || !newSlotData.slotStartTime || !newSlotData.slotEndTime) {
            toast.warning("Please fill all slot fields.");
            return;
        }

        const matchedDay = data.find((elem: any) => elem?.day === newSlotData?.day);
        const slotNumber = (matchedDay?.numberOfSlots ?? 0) + 1;
      
        let slotStart = newSlotData.slotStartTime;
        let slotEnd = newSlotData.slotEndTime;

        if(slotEnd==="00:00"){
            slotEnd="24:00"
        }
        if(slotStart==="00:00"&&slotStart===slotEnd){
            slotStart="00:00"
            slotEnd="24:00"
        }
        else if(timeStrToMinutes(slotStart)>timeStrToMinutes(slotEnd)){
            toast.warning("Please select an end time that comes after the start time.");
            return
        }

        const payload = {
            day: newSlotData.day,
            numberOfSlots: slotNumber,
            slots: [
                {
                    slotId: String(slotNumber),
                    slotName: newSlotData.slotName,
                    slotStartTime: slotStart,
                    slotEndTime: slotEnd,
                    agents: []
                }
            ]
        };

        const response: any = await addSlotToRoster(payload);
        if (response?.StatusCode === 200) {
            toast.success("Slot added successfully!");
            await fetchData();
            setNewSlotData({ day: "", slotName: "", slotStartTime: "", slotEndTime: "" });
        } else {
            toast.error(response?.response?.data?.message || "Failed to add slot");
            ;
        }
    };

    const formatISTTime = (istTime: string): string => {
        const [hours, minutes] = istTime.split(":").map(Number);
        const date = new Date(1970, 0, 1, hours, minutes);
        return date.toLocaleTimeString("en-IN", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    };

    const handleEditAgent = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        if (!value) {
            setAgentToEdit({})
            return
        }
        const agent = uniqueAgentMapping[value];
        const language = agent[value];
        setAgentToEdit({
            ...agent,
            language,
            name: value
        });


    };

const handleSave=async()=>{
    try{
        if(!agentToEdit?.language){
            toast.warning("Please select any agent to update")
            return
        }
        if(agentToEdit.language?.length===0){
            toast.warning("Please select any of the language to update the data")
             return
        }
        const handlePayload=createPayload()

        handlePayload.forEach(async(elem:any)=>{
            let payload={
                numberOfSlots:elem.slots?.length,
                slots:elem?.slots
            }
            await updateData(elem?._id, payload);
            
        })

        alert("Agent data updated successfully at all the places")

        setAgentToEdit({})
        await fetchData()
       
        

    }catch(err){
        console.log(err)
    }
}

const createPayload = () => {
  const filterData = data.filter((day: any) => {
    let found = false;

    day.slots.forEach((slot: any) => {
      slot.agents.forEach((agent: any) => {
        if (agentToEdit[agent.agentName]) {        
          agent.preferredLanguage = agentToEdit?.language;
          found = true;
          return
        }
      });
    });

    return found;
  });
  
   return filterData;
};






    return (
        <Layout>
            <Box p={4}>
                <Heading size="lg" textAlign="center" >
                    Manage Call Roster
                </Heading>
                <Box border="1px solid #E2E8F0" borderRadius="lg" p={5} mt={10}>
                    <Heading size="md" mt={3}>
                        Add Agent
                    </Heading>
                    <Wrap mt={10} spacing={3} >
                        {/* Day Select */}

                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Day
                                    <Tooltip
                                        label="This field is required. Please select the day to proceed."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                <Select name="Day" value={formData.Day} onChange={handleChange} placeholder="Select Day" rootProps={{
                                    borderWidth: '2px',
                                    borderColor: 'black',

                                }}>
                                    {data?.map((elem: any) => (
                                        <option key={elem.day} value={elem.day}>
                                            {elem.day}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                        </WrapItem>

                        {/* Slot Select */}
                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Slot
                                    <Tooltip
                                        label="This field is required. Available slots will only appear after selecting a day."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                <Select name="Slot" value={formData.Slot} onChange={handleChange} placeholder="Select Slot" borderWidth="2px" borderColor="black">
                                    {selectedSlots?.map((elem: any) => (
                                        <option key={elem.slotId} value={elem.slotId}>
                                            {`${elem.slotName} (${formatISTTime(elem.slotStartTime)} - ${formatISTTime(elem.slotEndTime)})`}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                        </WrapItem>

                        {/* Agent Name */}
                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Agent Name
                                    <Tooltip
                                        label="This field is required. Enter the full name of the agent."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                {/* <Input
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter Name of the Agent"
                                /> */}
                                {
                                   
                                    <Menu>
                                        <MenuButton as={Button} rightIcon={<ChevronDownIcon />} w="100%" h="40px" textAlign="left" bg="white" borderWidth="2px" borderColor="black">
                                            {formData.name || "Select Agent Name"}
                                        </MenuButton>
                                        <MenuList maxH="150px" overflowY="auto" borderWidth="2px" borderStyle="solid" borderColor="black">
                                            {agentData?.map((agent: any) => (
                                                <MenuItem key={agent?.agentName} onClick={() => {
                                                    setFormData((prev: any) => ({ ...prev, name: agent?.agentName }));
                                                    // Trigger the same logic as handleChange for name
                                                    let selectedAgent = agentData.find((a: any) => a.agentName === agent?.agentName);
                                                    if (selectedAgent) {
                                                        setFormData((prev: any) => ({
                                                            ...prev,
                                                            name: agent?.agentName,
                                                            agentId: selectedAgent.agentId,
                                                            number: selectedAgent.agentPhoneNumber,
                                                            languages: uniqueAgentMapping?.[selectedAgent?.agentName]?.[selectedAgent?.agentName] || [],
                                                        }));
                                                    }
                                                }}>
                                                    {agent.agentName}
                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                    </Menu>
                                }
                            </FormControl>
                        </WrapItem>

                        {/* Agent ID */}
                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Agent ID
                                    <Tooltip
                                        label="This field is required. Agent ID must be a valid email address (e.g., agent@example.com)."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                <Input
                                    type="email"
                                    name="agentId"
                                    value={formData.agentId}
                                    onChange={handleChange}
                                    placeholder="Agent id will be auto assigned"
                                    disabled={true}
                                    borderWidth="2px"
                                    borderColor="black"
                                />
                            </FormControl>
                        </WrapItem>

                        {/* Agent Number */}
                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Agent Number
                                    <Tooltip
                                        label="This field is required. Enter a valid 10-digit mobile number (e.g., 9876543210)."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                <Input
                                    type="tel"
                                    name="number"
                                    value={formData.number}
                                    onChange={handleChange}
                                    placeholder="Enter Agent Number"
                                    maxLength={10} 
                                    pattern="[0-9]{10}"
                                    inputMode="numeric" 
                                    disabled={true}
                                    borderWidth="2px"
                                    borderColor="black"
                                />
                            </FormControl>
                        </WrapItem>

                        {/* Agent Priority */}
                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Agent Priority
                                    <Tooltip
                                        label="This will be auto-assigned based on the slot selection."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                <Input
                                    name="priority"
                                    value={formData.priority}
                                    placeholder="Priority will be auto-assigned"
                                    isReadOnly
                                    borderWidth="2px"
                                    borderColor="black"
                                />
                            </FormControl>
                        </WrapItem>

                        {/* Preferred Languages */}
                        <WrapItem>
                            <FormControl w="300px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Preferred Languages
                                    <Tooltip
                                        label="This field is required. Select one or more languages the agent is comfortable speaking."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                <Menu closeOnSelect={false}>
                                    <MenuButton as={Button} rightIcon={<ChevronDownIcon />} borderWidth="2px" borderColor="black">
                                        {formData.languages.length > 0
                                            ? `${formData.languages.length} Language Selected` 
                                            : "Select Preferred Languages"}
                                    </MenuButton>
                                    <MenuList maxH="200px" overflowY="auto" borderWidth="2px" borderStyle="solid" borderColor="black">
                                        {languageOptions.map((lang) => (
                                            <MenuItem key={lang} _hover={{ bg: "gray.100" }} pointerEvents="none">
                                                <Checkbox
                                                   pointerEvents="auto"
                                                    isChecked={formData.languages.includes(lang)}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setFormData((prev: any) => ({
                                                            ...prev,
                                                            languages: checked
                                                                ? [...prev.languages, lang]
                                                                : prev.languages.filter((l: any) => l !== lang),
                                                        }));
                                                    }}
                                                >
                                                    {lang}
                                                </Checkbox>
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </Menu>
                            </FormControl>
                        </WrapItem>

                        {/* Add Agent Button */}
                        <WrapItem>
                            <Button colorScheme="green" size="md" mt="30px" onClick={handleAddAgent}>
                                Add Agent
                            </Button>
                        </WrapItem>
                    </Wrap>
                </Box>

                {/* Priority Table Component */}
                <Box mt={10} p={4} border="1px solid #E2E8F0" borderRadius="lg">
                    <Flex align="center" mb={4}>
                        <Heading size="md" mr={2}>
                            Add New Slot
                        </Heading>
                        <Tooltip
                            label="You can add a slot. Slot timing should be between 05:30 AM and 05:30 AM (next day)."
                            fontSize="sm"
                            hasArrow
                            placement="right"
                        >
                            <span>
                                <InfoIcon color="gray.500" cursor="pointer" />
                            </span>
                        </Tooltip>
                    </Flex>

                    <Wrap spacing={6}>
                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel display="flex" alignItems="center">
                                    Day
                                    <Tooltip
                                        label="This field is required. Please select the day to proceed."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>
                                <Select name="day" value={newSlotData.day} onChange={handleSlotChange} placeholder="Select Day" rootProps={{
                                    borderWidth: '2px',
                                    borderColor: 'black',

                                }}>
                                    {days.map((elem: any) => (
                                        <option key={elem} value={elem}>
                                            {elem}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                        </WrapItem>
                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel>Slot Name

                                    <Tooltip
                                        label="This field is required. Add the Name of the slot"
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>

                                </FormLabel>
                                <Input
                                    name="slotName"
                                    value={newSlotData.slotName}
                                    onChange={handleSlotChange}
                                    placeholder="Enter slot name"
                                    borderWidth="2px"
                                    borderColor="black"
                                />
                            </FormControl>
                        </WrapItem>
                        <WrapItem>
                            <WrapItem>
                                <FormControl w="200px" isRequired>
                                    <FormLabel>
                                        Start Time
                                        <Tooltip
                                            label="This field is required. Add the starting time of the slot."
                                            fontSize="sm"
                                            hasArrow
                                            placement="right"
                                        >
                                            <span>
                                                <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                            </span>
                                        </Tooltip>
                                    </FormLabel>

                                    <Box position="relative" zIndex={10}>
                                        <DatePicker
                                            selected={
                                                newSlotData.slotStartTime
                                                    ? new Date(`1970-01-01T${newSlotData.slotStartTime}`)
                                                    : null
                                            }
                                            onChange={(date: any) => {
                                                const time = date.toTimeString().slice(0, 5);
                                                setNewSlotData({ ...newSlotData, slotStartTime: time });
                                            }}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            dateFormat="HH:mm"
                                            placeholderText="Select or type time"
                                            popperPlacement="top-start"
                                            popperClassName="react-datepicker-zindex"
                                            className="chakra-input styled-datepicker"
                                        />

                                    </Box>
                                </FormControl>

                            </WrapItem>

                        </WrapItem>

                        <WrapItem>
                            <FormControl w="200px" isRequired>
                                <FormLabel>
                                    End Time
                                    <Tooltip
                                        label="This field is required. Add the Ending time of the slot."
                                        fontSize="sm"
                                        hasArrow
                                        placement="right"
                                    >
                                        <span>
                                            <InfoIcon ml={1} color="gray.500" cursor="pointer" />
                                        </span>
                                    </Tooltip>
                                </FormLabel>

                                <Box position="relative" zIndex={9999}>
                                    <DatePicker
                                        selected={
                                            newSlotData.slotEndTime
                                                ? new Date(`1970-01-01T${newSlotData.slotEndTime}`)
                                                : null
                                        }
                                        onChange={(date: any) => {
                                            const time = date.toTimeString().slice(0, 5);
                                            setNewSlotData({ ...newSlotData, slotEndTime: time });
                                        }}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Time"
                                        dateFormat="HH:mm"
                                        placeholderText="Select or type time"
                                        popperPlacement="top-start"
                                        popperClassName="datepicker-popper"
                                        wrapperClassName="chakra-datepicker-wrapper"
                                        className="chakra-datepicker-input"
                                    />
                                </Box>
                            </FormControl>

                        </WrapItem>

                        <WrapItem>
                            <Button mt="30px" colorScheme="green" onClick={handleAddSlot}>
                                Add Slot
                            </Button>
                        </WrapItem>
                    </Wrap>
                </Box>
                <Box mt={10} p={4} border="1px solid #E2E8F0" borderRadius="lg">
                    <Heading size="md" mr={2} mb={4}>
                            Update Agent
                        </Heading>
                     <Flex align="center" mb={4} >
                        <Select
                            placeholder="Select Agent for Language Update"
                            onChange={handleEditAgent}
                            maxWidth={300}
                            mr={10}
                            value={agentToEdit?.name || ""}
                            rootProps={{
                                    borderWidth: '2px',
                                    borderColor: 'black',

                                }}
                        >
                            <option value="" disabled hidden>
                                Select Agent for Language Update
                            </option>
                            {Object.keys(uniqueAgentMapping)
                                .sort((a, b) => a.localeCompare(b))
                                .map((key) => (
                                    <option value={key} key={key}>
                                        {key}
                                    </option>
                                ))}
                        </Select>

                        <Menu closeOnSelect={false}>
                            <MenuButton
                                as={Button}
                                rightIcon={<ChevronDownIcon />}
                                isDisabled={!Array.isArray(agentToEdit?.language)}
                                borderWidth="2px"
                                borderColor="black"
                                onClick={(e) => {
                                    if (!Array.isArray(agentToEdit?.language)) {
                                        e.preventDefault(); // Prevent menu from opening
                                        alert("Please select an agent before choosing languages");
                                    }
                                }}
                            >
                                {Array.isArray(agentToEdit?.language) && agentToEdit.language.length > 0
                                    ? `${agentToEdit.language.length} Language${agentToEdit.language.length > 1 ? "s" : ""} Selected`
                                    : "Select Preferred Languages"}
                            </MenuButton>

                            <MenuList maxH="200px" overflowY="auto" borderWidth="2px" borderStyle="solid" borderColor="black" zIndex={2000}>
                                {Array.isArray(agentToEdit?.language) && (() => {
                                    const selectedLangs = languageOptions
                                        .filter((lang) => agentToEdit.language.includes(lang))
                                        .sort((a, b) => a.localeCompare(b));

                                    const unselectedLangs = languageOptions
                                        .filter((lang) => !agentToEdit.language.includes(lang))
                                        .sort((a, b) => a.localeCompare(b));

                                    const sortedLanguages = [...selectedLangs, ...unselectedLangs];

                                    return sortedLanguages.map((lang) => {
                                        const isChecked = agentToEdit.language.includes(lang);

                                        return (
                                            <MenuItem
                                                key={lang}
                                                _hover={{ bg: "gray.100" }}
                                                pointerEvents="none"
                                            >
                                                <Checkbox
                                                    pointerEvents="auto"
                                                    isChecked={isChecked}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setAgentToEdit((prev: any) => {
                                                            const prevLangs = Array.isArray(prev.language) ? prev.language : [];

                                                            const updatedLangs = checked
                                                                ? [...prevLangs, lang]
                                                                : prevLangs.filter((l: string) => l !== lang);

                                                            return {
                                                                ...prev,
                                                                language: updatedLangs,
                                                            };
                                                        });
                                                    }}
                                                >
                                                    {lang}
                                                </Checkbox>
                                            </MenuItem>
                                        );
                                    });
                                })()}
                            </MenuList>
                        </Menu>


                        <Button ml={15} colorScheme="green" onClick={handleSave}>Save</Button>
                     </Flex>

                </Box>


                {isLoading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="200px" 
                    >
                        <Spinner size="lg" />
                    </Box>
                ) : (
                    <Box mt={10}>
                        <PriorityDragDrop detailsData={data} onUpdateData={setData} />
                    </Box>
                )}

            </Box>

        </Layout>
    )
}


